<template>
  <div class="summary-delivery">
    <div class="card card-delivery">
      <div class="tittle">
        <span>Tipo de entrega:</span>
        <span>{{ typeDelivery }}</span>
        <a @click.prevent="editAddress">Cambiar</a>
      </div>
      <div class="content" v-if="homeDelivery">
        <p>
          <span>Dirección:</span><span>{{ address }}</span>
        </p>
        <p>
          <span>Fecha:</span><span>{{ summary.dateTime.label }} - {{ summary.dateTime.hour }}</span>
        </p>
        <p>
          <span>Costo:</span><span>{{ `S/ ${cost}` }}</span>
        </p>
        <p>
          <span>Recepción:</span
          ><span>{{ summary.address.firstName }} {{ summary.address.lastName }}</span>
        </p>
      </div>
      <div class="content" v-else>
        <p>
          <span>Cliente:</span><span> {{ customer.firstName }} {{ customer.lastName }}</span>
        </p>
        <p>
          <span>{{ customer.documentType }}</span
          ><span> {{ documentNumber }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SummaryDelivery',
  data() {
    return {
      cost: ''
    };
  },
  computed: {
    documentNumber() {
      return this.customer.documentType === 'DNI' ? this.customer.dniUser : this.customer.rucDni;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    summary() {
      return this.$store.getters.delivery;
    },
    homeDelivery() {
      return this.$store.state.delivery.isHomeDelivery;
    },
    typeDelivery() {
      return this.homeDelivery ? 'Envio a domicilio' : 'Tienda';
    },
    zones() {
      return this.$store.getters.getZones;
    },
    address() {
      if (!this.isObjEmpty(this.summary.address)) {
        const { ubigeo, address, lot } = this.summary.address;
        return `${ubigeo[0].name}, ${ubigeo[1].name} ${ubigeo[2].name}, ${address} - ${lot}`;
      } else {
        return '';
      }
    }
  },
  methods: {
    editAddress() {
      this.$emit('returnAddress');
    },
    deliveryCost() {
      if (this.homeDelivery) {
        const zoneIdCustomer = this.summary.address.zoneId;
        const deliveryCost = this.zones.filter((elem) => elem.id === zoneIdCustomer.toString());
        this.cost = deliveryCost[0].methods[0].feeValue;
        const zoneId = deliveryCost[0].methods[0].id;
        const data = {
          zoneId: zoneId,
          cost: this.cost
        };
        this.$store.commit('setCost', data);
      }
    }
  },
  mounted() {
    this.deliveryCost();
  }
};
</script>
<style lang="scss">
.summary-delivery {
  .card-delivery {
    background-color: whitesmoke;
  }

  .card {
    border-radius: 0.25rem;
    margin-top: 15px;
    padding: 20px;
    border: none;
  }
  .tittle {
    font-weight: bold;
    margin-bottom: 0.5rem;
    span:nth-child(n) {
      margin-right: 3px;
    }
    a {
      cursor: pointer;
      font-size: 12px;
      margin-left: 5px;
      background-color: #ffc107;
      padding: 5px 10px;
      border-radius: 8px;
    }
    a:hover {
      background-color: #e0a800;
      border-color: #d39e00;
    }
  }
  p {
    margin-bottom: 0.5rem;
    span:nth-child(1) {
      font-weight: bold;
      margin-right: 3px;
    }
  }
}
</style>
